import React, { useEffect, useState } from 'react'
import { Layout } from 'antd'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { listDatabases } from 'states/modules/textDatabases'
import {
	getDetail,
	listItems,
	getText,
	newText,
} from '~/states/modules/databaseDetail'

import MainLayout from '~/components/mainLayout'
import TextDatabaseItemsListing from './components/textDatabaseItemsListing'
import DatabaseTextEditor from './components/textDatabaseTextEditor'

const TextDatabase = () => {
	const { id } = useParams()
	const dispatch = useDispatch()
	const history = useHistory()

	const [editedText, setEditedText] = useState(false)

	useEffect(() => {
		dispatch(getDetail({ id }))
		dispatch(listItems({ id }))
	}, [dispatch, id])

	const handleReturnParent = (i) => {
		if (i === 1) {
			setEditedText(false)
			dispatch(listItems({ id }))
		} else {
			dispatch(listDatabases())
			history.push('/textdatabases')
		}
	}

	const handleCreateText = (title) => {
		dispatch(newText({ description: title }))
		setEditedText(title)
	}

	const handleEditText = (row) => {
		dispatch(getText({ id: row.id }))
		setEditedText(row.id)
	}

	const handleSaveText = () => {
		setEditedText(false)
	}

	return (
		<MainLayout selectedKey={'databases'}>
			<Layout style={{ padding: '0', background: '#fff', width: '100%' }}>
				{!editedText ? (
					<TextDatabaseItemsListing
						onReturnParent={handleReturnParent}
						onCreateText={handleCreateText}
						onEditText={handleEditText}
						idDataBase={id}
					/>
				) : (
					<DatabaseTextEditor
						id={editedText}
						onReturnParent={handleReturnParent}
						onSaveText={handleSaveText}
					/>
				)}
			</Layout>
		</MainLayout>
	)
}

export default TextDatabase
